export default "__VITE_ASSET__WN0HS_u2__"